module.exports = __webpack_public_path__ + "static/media/bg.38183f96.png";